import React from 'react';
import ArrowDiagonalIcon from '../../icons/ArrowDiagonalIcon';

export const OddsIndicator = ({ initialOdds, odds }: { initialOdds?: number; odds?: number }) => {
    if (!initialOdds) {
        return null;
    }
    return <ArrowDiagonalIcon className={initialOdds > odds ? 'failing' : 'rising'} />;
};
